export const BACKGROUND_VERTICAL_PADDING = 8;
export const BACKGROUND_HORIZONTAL_PADDING = 12;
